import styled from "styled-components";

import Button from "core/Button";

import { convertPxToRem } from "frontend/components/helpers";

export const ControlsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const SelectedControlsContainer = styled.div`
    display: flex;

    & > *:not(:last-child) {
        margin-right: ${convertPxToRem({ px: 24 })};
    }
`;

export const OtherControlsContainer = styled.div`
    display: flex;
    justify-content: flex-end;

    & > *:not(:first-child) {
        margin-left: ${convertPxToRem({ px: 24 })};
    }
`;

export const ToolbarButton = styled(Button).attrs({
    size: "xs",
    styleType: "outline"
})``;
